<h2>Physical Characteristics</h2>
<span class="sub-text"
  >Sum of the "typical / actual %" by weight must add up to 100%</span
>

<span class="sub-text">
  <h4><u>Please choose typical/actual % or range</u></h4>
  <label>
    Typical / Actual %
    <mat-slide-toggle
      [tabIndex]="tabIndex"
      [checked]="isToggleEnabled"
      (change)="isToggleEnabled = $event.checked"
    >
      Low % to High %</mat-slide-toggle
    >
  </label>
</span>
<form [formGroup]="form" class="content-align-left">
  <div class="form-section" *ngIf="form">
    <digital-platform-waste-component-rows
      [tabIndex]="tabIndex + 1"
      formControlName="physicalComponents"
      [isToggled]="isToggleEnabled"
      [sum]="sumOfTypical"
      [labels]="labels"
      [isRequired]="isRequired"
      [isLegacy]="isLegacy"
      (lastTabIndex)="onLastTabIndexChange($event)"
    >
    </digital-platform-waste-component-rows>

    <div *ngIf="!isToggleEnabled" class="input-container">
      Remaining Typical / Actual % Sum :
      {{ getRemainingActuals() | number: '1.0-4' }} %
    </div>
    <div *ngIf="isToggleEnabled" class="input-container">
      Remaining High % Sum :
      {{ getRemainingActuals() | number: '1.0-4' }} %
    </div>

    <mat-error
      *ngIf="
        !isToggleEnabled &&
        form.get('physicalComponents')?.hasErrorAndTouched('sumOver100')
      "
    >
      Sum of Typical/Actual % must be less than or equal to 100%
    </mat-error>

    <mat-error
      *ngIf="
        isLegacy === false &&
        !isToggleEnabled &&
        sumOfTypical &&
        sumOfTypical < 100
      "
    >
      Sum of the "typical / actual %" by weight must add up to 100%
    </mat-error>
    <mat-error
      *ngIf="
        isLegacy === false &&
        isToggleEnabled &&
        sumOfTypical &&
        sumOfTypical < 100
      "
    >
      Sum of the "High %" by weight must add up to at least 100%
    </mat-error>
  </div>

  <div class="form-section">
    <div class="column-2">
      <div class="col">
        <div class="input-container">
          <label
            >Dominant Color
            <mat-icon-button
              mat-icon-button
              class="btn-hint"
              matTooltip="If the color is variable, provide the most dominant color."
            >
              <mat-icon class="help-icon">help</mat-icon>
            </mat-icon-button>
          </label>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-select
              [tabIndex]="lastTabIndex + 1"
              formControlName="dominantColor"
              placeholder="Select Dominant Color"
            >
              <mat-option
                *ngFor="let dominantColor of dominantOptions.dominantColor"
                [value]="dominantColor"
              >
                {{ dominantColor }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="errorHandling('dominantColor', 'required')">
              Dominant Color is <strong>Required</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="input-container">
          <mat-checkbox
            [tabIndex]="lastTabIndex + 2"
            (change)="onDominantColorChange($event)"
            [(checked)]="isDominantColorSelected"
          >
            Secondary color
          </mat-checkbox>
        </div>

        <div class="input-container" *ngIf="isDominantColorSelected">
          <ng-container>
            <label>Select Secondary Colors </label>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-select
                [tabIndex]="lastTabIndex + 3"
                placeholder="Select Other Color"
                formControlName="otherColor"
                multiple
              >
                <mat-option
                  *ngFor="let otherColor of dominantOptions.dominantColor"
                  [value]="otherColor"
                >
                  {{ otherColor }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="errorHandling('otherColor', 'required')">
                Secondary Color is <strong>Required</strong>
              </mat-error>
            </mat-form-field>
          </ng-container>
        </div>
      </div>

      <div class="col">
        <div class="input-container">
          <label>Odor</label>
          <mat-radio-group fxLayout="column" formControlName="odorStrength">
            <mat-radio-button [tabIndex]="lastTabIndex + 4" value="strong"
              >Strong</mat-radio-button
            >
            <mat-radio-button [tabIndex]="lastTabIndex + 4" value="mild"
              >Mild</mat-radio-button
            >
            <mat-radio-button [tabIndex]="lastTabIndex + 4" value="slight"
              >Slight</mat-radio-button
            >
            <mat-radio-button [tabIndex]="lastTabIndex + 4" value="none"
              >None</mat-radio-button
            >
            <mat-error *ngIf="errorHandling('odorStrength', 'required')">
              Odor is <strong>Required</strong>
            </mat-error>
          </mat-radio-group>
        </div>
        <div class="input-container" *ngIf="showOdorDescription">
          <label> Odor Description </label>
          <mat-form-field appearance="outline">
            <input
              [tabIndex]="lastTabIndex + 5"
              maxlength="24"
              matInput
              formControlName="odorDescription"
            />
            <mat-error *ngIf="errorHandling('odorDescription', 'required')">
              Odor Description is <strong>Required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</form>
